interface IParams {
  url?: string
  userId: string
  provider: string
  sessionToken: string
}

export function getResetPasswordURL({ url, userId, sessionToken, provider }: IParams) {
  return `${url}?userId=${userId}&sessionToken=${sessionToken}&origin=${provider}`
}
